import { FileEntity } from '@shared/models/file-entity';
import {
  CONTENT_TYPE_PDF,
  CONTENT_TYPE_STD,
  CONTENT_TYPE_XML,
  CSV_CONTENTTYPE,
  TSV_CONTENTTYPE,
} from './files';

export enum DownloadFileExtension {
  CMP = 'CMP',
  STD = 'STD',
  STD2 = 'STD2',
  XML = 'XML',
  CSV = 'CSV',
  TSV = 'TSV',
  PDF = 'PDF',
}

export const SeperatorString = {
  comma: ',',
  tab: '\t',
};

export const DownloadFileTypes = {
  CSV: {
    seperator: SeperatorString.comma,
    fileExtension: DownloadFileExtension.CSV,
    contentType: CSV_CONTENTTYPE,
  } as FileEntity,
  TSV: {
    seperator: SeperatorString.tab,
    fileExtension: DownloadFileExtension.TSV,
    contentType: TSV_CONTENTTYPE,
  } as FileEntity,
  CMP: {
    fileExtension: DownloadFileExtension.CMP,
    contentType: CONTENT_TYPE_STD,
    fileDisplayTitle: 'CMP: (Field Segments)',
  } as FileEntity,
  STD: {
    fileExtension: DownloadFileExtension.STD,
    contentType: CONTENT_TYPE_STD,
    fileDisplayTitle: 'STD: (Field Segments)',
  } as FileEntity,
  STD2: {
    fileExtension: DownloadFileExtension.STD2,
    contentType: CONTENT_TYPE_STD,
    fileDisplayTitle: 'STD2: (Fixed Width)',
  } as FileEntity,
  XML: {
    fileExtension: DownloadFileExtension.XML,
    contentType: CONTENT_TYPE_XML,
  } as FileEntity,
  PDF: {
    fileExtension: DownloadFileExtension.PDF,
    contentType: CONTENT_TYPE_PDF,
  } as FileEntity,
};
